<template>
  <base-module-modal
      v-if="this.config"
      :added-modules="preferences.passedModules"
      :modal-name="this.$options.name"
      :closing-offered="false"
      :confirmation-always-enabled="true"
      :discarding-offered="false"
      :text-hint="textHint"
      :extra-group="getTakenModulesStructure()"
      :mark-extra-group="true"
      @confirm-operation="updatePassedModules"
      icon-modal="task_alt"
      :modal-subtitle="'In your stored plan the modules below were selected. Please check that you passed them and add more passed modules if necessary.'"
      :modal-title="'Select passed modules since '+ this.formatSemester(preferences.saveDetails.savedSemester)+''"
  >
  </base-module-modal>
</template>

<script>

import BaseModuleModal from "@/components/modals/BaseModuleModal.vue";
import {mapGetters, mapState} from "vuex";

export default {
  name: "SaveSemesterChangedModal",
  components: {BaseModuleModal},
  computed: {
    ...mapGetters(["addedPassedModules","frontendCurrentSemester"]),
    ...mapState(["config","preferences", "promptedPassedModules"]),
    textHint() {
      return this.preferences.degree === "msc" ? "If you cannot find a module, search for 'Special topic' (for " +
          "Mathematics) or 'Module' (for other Sciences) and select a module of the fitting area with the right " +
          "credit amount." : "";
    },
    currentSemester() {
      return this.formatSemester(this.frontendCurrentSemester);
    }
  },
  methods: {
    updatePassedModules(markedModules) {
      const modulesToRemove = this.preferences.passedModules.filter(module => !markedModules.includes(module))
      const modulesToAdd = markedModules.filter(module => !this.preferences.passedModules.includes(module))
      modulesToRemove.forEach(module => {
        this.$store.commit("REMOVE_PASSED_MODULE", {passedModule:module, bulk:true});
      })
      modulesToAdd.forEach(module => {
        this.$store.commit("ADD_PASSED_MODULE", {passedModule: module, bulk:true});
      })

      if (!this.promptedPassedModules) {
        /* Temporary hack: sets max semester ECTS to 36 to counter workload-ects-discrepancy */
        this.hackSemesterPreferences();
      }
      this.$store.commit("SET_PROMPTED_PASSED_MODULES");
      this.$store.commit("SAVE_STATE");
      
    },
    hackSemesterPreferences() {
      if (this.preferences.degree === "bsc" && this.preferences.major === "mathematics"
          && ["w24", "s25"].includes(this.preferences.startSemester)
          && !this.preferences.passedModules.includes("MA0006")
          && !this.preferences.passedModules.includes("MA0007")) {
        const semester = this.preferences.startSemester === "w24" ? 2 : 1;
        this.$store.commit("UPDATE_SEMESTER_PREFERENCE", {semester: semester, key: "default", value: false, bulk: true});
        this.$store.commit("UPDATE_SEMESTER_PREFERENCE", {semester: semester, key: "maxEcts", value: 36, bulk: true});
      }
    },
    getTakenModulesStructure(){
      const structure ={
        id: "taken",
        name: 'Modules taken since the last saved plan',
        moduleids: [...this.preferences.saveDetails.taken]
      }

      return structure;
    },
    formatSemester(semesterCode){
      if (!semesterCode) return ""; 
      const season = semesterCode.startsWith("w") ? "winter semester" : "summer semester";
      const year = `20${semesterCode.slice(1)}`; 
      return `${season} ${year}`;
    }
  },
};
</script>

